import styled from 'styled-components';
import tw from 'twin.macro';

export const FormTitle = styled.div``;

export const FormDescription = styled.div``;

export const CustomUIImage = styled.img`
  ${tw`w-full h-full mb-4`}
  ${(props) => props.css}
`;
